import CanManageServices from 'Components/Guards/CanManageServices';

export default {
    'can-manage-services': CanManageServices
};
